import { configureStore } from '@reduxjs/toolkit';

import authReducer from "./AuthSlice/authSlice";
import jobReducer from "./JobSlice/jobSlice";
import companyReducer from "./CompanySlice/companySlice";
import hsignalReducer from "./HSignalSlice/hsignalSlice";
import contactReducer from "./ContactSlice/contactSlice";
import savedJobsReducer from "./SavedJobSlice/savedJobSlice";
import savedCompaniesReducer from "./SavedCompanySlice/savedCompanySlice";
import dailyTasksReducer from "./DailyTasksSlice/dailyTaskSlice";
import resumeReducer from "./ResumeSlice/resumeSlice";
import liAuthReducer from "./LIAuthSlice/liAuthSlice";
import chatsReducer from "./ChatSlice/chatSlice";
import feedsReducer from "./FeedSlice/feedSlice";
import paymentReducer from "./PaymentSlice/paymentSlice";
import aiChatReducer from "./AIChatSlice/aiChatSlice";
import companyStrategyReducer from "./CompanyStrategySlice/companyStrategySlice";
import activeSprintsReducer from "./ActiveSprintSlice/activeSprintSlice";
import digestReducer from "./DigestSlice/digestSlice";

const store = configureStore({
    reducer: {
        auth: authReducer,
        jobs: jobReducer,
        companies: companyReducer,
        hsignal: hsignalReducer,
        contacts: contactReducer,
        savedJobs: savedJobsReducer,
        savedCompanies: savedCompaniesReducer,
        dailyTasks: dailyTasksReducer,
        resume: resumeReducer,
        liauth: liAuthReducer,
        chats: chatsReducer,
        feeds: feedsReducer,
        payments: paymentReducer,
        aiChat: aiChatReducer,
        companyStrategy: companyStrategyReducer,
        activeSprints: activeSprintsReducer,
        digest: digestReducer
    }
})

export default store;